import React from 'react';

const WorkbenchPanel = ({ children }) => {
    return (
        <div className="appWorkbenchPanel">{children}</div>
    )
}

export default WorkbenchPanel;